import React from 'react'
import { Tab, Nav } from 'react-bootstrap';
import HeadlineChild from './headlineTabContent';
import TrendingChild from './trendingTabContent';
import VideosChild from './videosTabContent';
import "../../assets/css/scss/component/_tabView.scss"
import { IPostData } from '../../interfaces/post';

type ITabSection = {
    headlines: IPostData[],
    videos: IPostData[],
    trendings: IPostData[],
}

export default function TabView(props: ITabSection) {
    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Nav bsPrefix="default-tabview nav nav-tabs theme-gray" as="ul">
                <Nav.Item as="li">
                    <Nav.Link className="theme-white bold" eventKey="first">
                        <i className="icon-Asset-7 theme-green"></i>Headline
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Nav.Link className="theme-white bold" eventKey="second">
                        <i className="icon-Asset-8 theme-green"></i>Tranding
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Nav.Link className="theme-white bold" eventKey="third">
                        <i className="icon-Asset-9 theme-green"></i>Videos
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <Tab.Pane eventKey="first">
                    <HeadlineChild headlines={props.headlines} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                    <TrendingChild trendings={props.trendings} />
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                    <VideosChild videos={props.videos} />
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    )
}
